import { intlReducer } from 'react-intl-redux';

type IntlState = { locale: string; messages: Record<string, string> };

export const CORRECOES_DO_VOLTO: Record<string, Record<string, string>> = {
  'pt-BR': { 'Selected items - x of y': 'de' },
  es: { 'Selected items - x of y': 'de' },
  de: { 'Selected items - x of y': 'von' },
};

export function intlCorrigidoReducer(
  state: IntlState | undefined,
  action: { type: string },
): IntlState {
  const proximo = intlReducer(state, action) as IntlState;
  const correcoes = CORRECOES_DO_VOLTO[proximo?.locale];
  if (!correcoes || !proximo.messages) return proximo;
  const faltaCorrigir = Object.entries(correcoes).some(
    ([id, texto]) => proximo.messages[id] !== texto,
  );
  if (!faltaCorrigir) return proximo;
  return { ...proximo, messages: { ...proximo.messages, ...correcoes } };
}
